import { Injectable } from '@angular/core';
import { PublicationRemoteRepositoryService } from 'src/app/module/actions/data/repository/publication-remote-repository.service';
import { z } from 'zod';

const FileSchema = z.object({
  originalFileName: z.string(),
  fileBase64: z.string(),
  fileExtension: z.string(),
});

export const PublicationCreateInputDtoSchema = z.object({
  userId: z.number(),
  dateIndex: z.string().datetime(), // validates ISO date string
  title: z.string(),
  message: z.string(),
  datePublication: z.string().datetime(), // validates ISO date string
  files: z.array(FileSchema),
  organicEntityId: z.number(),
  processId: z.number()
});

export type PublicationCreateInputDto = z.infer<typeof PublicationCreateInputDtoSchema>;

@Injectable({
  providedIn: 'root'
})
export class PublicationCreateUseCaseService {

  constructor(
    private remote: PublicationRemoteRepositoryService
  ) { }

  execute(input: PublicationCreateInputDto) {
    return this.remote.createPublication(input);
  }
}
